import en from "@/localization/en.json";
import useCounter from "@/utils/hooks/useCounter";
import { PropTypes } from "prop-types";

const CountDown = (props) => {
  const { onResendOtpRequest } = props;

  const { resetTimer, timer, isTimerCompleted } = useCounter();

  return (
    <div>
      {!isTimerCompleted ? (
        <p className="text-center text-[#414E5F]">
          {en["resetPassword.resend_code"]} {timer}
        </p>
      ) : (
        <p
          className="text-center text-[#E81E61] cursor-pointer"
          onClick={() => {
            onResendOtpRequest();
            resetTimer();
          }}
        >
          {en["resetPassword.resend_otp"]}
        </p>
      )}
    </div>
  );
};

CountDown.propTypes = {
  onResendOtpRequest: PropTypes.func,
};

export default CountDown;
